{
  "favoriteBoardmakerSoftware": "favoritprogramvara för Boardmaker",
  "planDetailsStartTrial": "Starta din gratis testperiod idag, vilken ger åtkomst i 30 dagar!",
  "community": {
    "summary": "Dra fördel av det redan tillgängliga utbildningsmaterialet som delats av föräldrar, lärare och terapeuter! Spara tid genom att söka och filtrera aktiviteter och mallar. Lägg sedan helt enkelt till dem i ditt konto och du är klar att redigera och använda dem med din favoritmjukvara från Boardmaker. Med 60 000 gratis utskrivningsbara och interaktiva aktiviteter och fler än 500 000 medlemmar finns ingen anledning att vänta.",
    "topReasons": {
      "header": "Anledningar att registrera sig på myBoardmaker Community",
      "points": [
        "Dela fina aktiviteter som du har skapat.",
        "Använd kraftfulla sökfunktioner för att hitta precis vad du behöver.",
        "Hitta aktiviteter som skapats av Boardmakers professionella utbildningsteam.",
        "Sök efter aktiviteter som är anpassade till Common Core-standarder.",
        "Gå med i grupper som är specifika för dina intressen."
      ]
    },
    "summaryEnd": "Dela och utforska interaktivt och utskrivningsbart material som tillhandahåller beteendestöd och främjar elevernas oberoende samt utveckling av färdigheter, helt gratis",
    "features": [
      {
        "featureTitle": "Hitta",
        "featureDescription": "Upptäck anpassade kursplaner, visuella scheman, kommunikationskartor, standardinriktade utbildningsaktiviteter och annat stödmaterial som har utvecklats och använts av föräldrar, terapeuter och lärare."
      },
      {
        "featureTitle": "Dela",
        "featureDescription": "Ladda upp aktiviteter du har skapat, delta i diskussioner, skapa allmänna och privata grupper för delning och mycket mer."
      },
      {
        "featureTitle": "Använd",
        "featureDescription": "Lagra dina aktiviteter online och ha åtkomst till den från vilken dator som helst."
      },
      {
        "featureTitle": "Anslut",
        "featureDescription": "Anslut dig till andra som undervisar i samma ämne eller årskurs, utbyt idéer med föräldrar som står inför samma utmaningar som du gör och dela de lösningar du har skapat."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senare"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senare"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senare"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuell"],
        ["Firefox", "v38.0", "aktuell"],
        ["Safari", "v11.0", "aktuell"],
        ["Edge", "v83.0.478.45", "aktuell"],
        ["Internet Explorer", "v10.0", "v11.0 eller senare"]
      ]
    }
  },
  "personal": {
    "summary": "För enkelt in kraften hos Boardmaker i ditt hem. En personlig prenumeration på myBoardmaker ger din möjlighet att spela en aktiv roll i ditt barns framgång genom att ge konsekvens hemma, i skolan och på terapin. Detta gör att möjligheten att lära går bortom skoldagen och t.o.m. skolåret. Nätverka med andra föräldrar i Boardmaker Community för att dela det du skapat och få många nya idéer.",
    "topReasons": {
      "header": "Anledningar att registrera sig på myBoardmaker Personal",
      "points": [
        "Ta med engagerande och interaktiva aktiviteter till valfri dator eller iPad",
        "Skriv ut aktiviteter när du behöver dem",
        "Som förälder, ta en aktiv del i ditt barns inlärning hemma",
        "Ta med kul och engagerande material var du än ska och skapa eller redigera aktiviteter från vilken dator som helst"
      ]
    },
    "summaryEnd": "Starta din gratis testperiod idag, vilken ger fullständig åtkomst i 30 dagar!",
    "features": [
      {
        "featureTitle": "Skapa och redigera",
        "featureDescription": "Skapa och redigera symbolanpassade aktiviteter såsom visuella scheman för att planera dagen, individanpassade böcker och inlärningsmaterial, och beteendestöd! Med ett bibliotek med fler än 80 000 symboler att välja mellan, plus nya som läggs till varannan vecka, är möjligheterna oändliga. Behöver du mer? Använd vårt webbsökningsalternativ för att hämta mediafiler till ditt projekt."
      },
      {
        "featureTitle": "Skriv ut och spela",
        "featureDescription": "Skriv ut dina egna aktiviteter eller andra du hittar i Boardmaker Community direkt från din webbläsare för att använda med ditt barn. Vill du öka engagemanget? Prova våra interaktiva mallar och aktiviteter. Barn och föräldrar kan enkelt utföra aktiviteter genom gratisappen Student Center på sin surfplatta eller kommunikationsenhet."
      },
      {
        "featureTitle": "Lär ut och utöka",
        "featureDescription": "Kom igång med ditt barns läs- och skrivförmåga med hjälp av våra tre lättanvända kursplaner. Börja med Core First Learning – ett verktyg som hjälper barnet att lära sig betydelsen, användningen och placeringen av högfrekventa basord. Idealiskt för individer som använder core-baserade AKK-system eller de som håller på att lära sig läsa! Tillämpa dessa nya förmågor till årskursanpassad litteratur genom att använda Book Bridge och börja sedan skapa ordkunskap genom att utforska historia, geografi, levnad och kultur med Expedition Education."
      },
      {
        "featureTitle": "Hitta och dela",
        "featureDescription": "Varför skapa hjulet på nytt? Välj bland fler än 60 000 gratis befintliga utskrivningsbara och interaktiva aktiviteter och 1100 kategoriserade offentliga grupper i Boardmaker Community - den största delningsgemenskapen av sitt slag i världen. Du kan också ladda upp aktiviteter du har skapat till ditt Boardmaker Online Community-konto och dela dem med föräldrar, terapeuter eller elevens stödteam."
      },
      {
        "featureTitle": "Övervaka och spåra",
        "featureDescription": "Övervaka och spåra ditt barns framsteg när de utför aktiviteter för att säkerställa att de lyckas och hjälpa dig fastställa det effektivaste tillvägagångssättet."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senare"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senare"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senare"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuell"],
        ["Firefox", "v38.0", "aktuell"],
        ["Safari", "v11.0", "aktuell"],
        ["Edge", "v83.0.478.45", "aktuell"],
        ["Internet Explorer", "v10.0", "v11.0 eller senare"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional är det mest kompletta systemet för speciallärare, logopeder, arbetsterapeuter, beteendeterapeuter, med flera, för att hitta, skapa, organisera och tillhandahålla anpassat visuellt stöd, symbolbaserad kommunikation och terapiaktiviteter som uppfyller behoven hos eleverna i ditt klassrum eller din patientstock.",
    "topReasons": {
      "header": "Anledningar att registrera sig på myBoardmaker Professional",
      "points": [
        "Hantera och tilldela elevaktiviteter när som helst och från vilken dator som helst",
        "Använd det stora biblioteket med provaktiviteter eller skapa din egen",
        "Elever får åtkomst till instruktionsaktiviteter från valfri dator eller iPad i skolan eller hemma",
        "Samla data och spåra elevens framsteg mot sina individuella elevmål och utbildningsstandarder",
        "Inbyggda verktyg hjälper dig att samarbeta och dela med andra teammedlemmar"
      ]
    },
    "summaryEnd": "Starta din gratis provperiod idag, vilken ger fullständig åtkomst i 30 dagar!",
    "features": [
      {
        "featureTitle": "Skapa och redigera",
        "featureDescription": "Skapa och redigera symbolanpassade aktiviteter såsom visuella scheman för att planera dagen, individanpassade böcker och inlärningsmaterial, och beteendestöd! Med ett bibliotek med fler än 80 000 symboler att välja mellan, plus nya som läggs till varannan vecka, är möjligheterna oändliga. Behöver du mer? Använd vårt webbsökningsalternativ för att hämta mediafiler till ditt projekt."
      },
      {
        "featureTitle": "Skriv ut och spela",
        "featureDescription": "Skriv ut dina egna aktiviteter eller andra du hittar i Boardmaker Community direkt från din webbläsare för att använda med ditt barn. Vill du öka engagemanget? Prova våra interaktiva mallar och aktiviteter. Barn och föräldrar kan enkelt utföra aktiviteter genom gratisappen Student Center på sin surfplatta eller kommunikationsenhet."
      },
      {
        "featureTitle": "Lär ut och utöka",
        "featureDescription": "Hjälp eleven att ta nästa steg på sin utbildningsresa med tillgång till tre robusta, standardinriktade kursplaner. Boardmaker Instructional Solutions, som ingår i din prenumeration på Boardmaker Online, innehåller fler än 140 lektionsplaner som beskrivs steg för steg, fler än 1500 differentierade och standardinriktade aktiviteter, 300+ utskrivningsbara och tillgängliga böcker, verktyg för klassrumsadministration, frågesporter, spel, recept, pyssel, m.m."
      },
      {
        "featureTitle": "Hitta och dela",
        "featureDescription": "Varför skapa hjulet på nytt? Välj bland fler än 60 000 gratis befintliga utskrivningsbara och interaktiva aktiviteter och 1100 kategoriserade offentliga grupper i Boardmaker Community - den största delningsgemenskapen av sitt slag i världen. Du kan också ladda upp aktiviteter du har skapat till ditt Boardmaker Online Community-konto och dela dem med föräldrar, terapeuter eller elevens stödteam."
      },
      {
        "featureTitle": "Övervaka och spåra",
        "featureDescription": "Övervaka och spåra ditt barns framsteg när de utför aktiviteter för att säkerställa att de lyckas och hjälpa dig fastställa det effektivaste tillvägagångssättet."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senare"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senare"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senare"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuell"],
        ["Firefox", "v38.0", "aktuell"],
        ["Safari", "v11.0", "aktuell"],
        ["Edge", "v83.0.478.45", "aktuell"],
        ["Internet Explorer", "v10.0", "v11.0 eller senare"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization stöder det multidisciplinära teamet genom att tillhandahålla anpassade aktiviteter, beteendestöd och mått för framstegen mot standarder och mål. \n\nDet molnbaserade systemet myBoardmaker tillhandahåller ett ramverk för konsekvens och samarbete inom hela organisationen och personalen kan jobba varifrån som helst. Dessutom ger det åtkomst till ett bibliotek med mer än 60 000 förkonfigurerade aktiviteter, tre kompletta studieplanprogram och fler än 80 000 bildkommunikationssymboler för att snabbt komma igång med lektionsplaneringen. Nu kan personalen snabbt tillhandahålla elever eller klienter med utskrivna och interaktiva aktiviteter via Boardmaker Student Center för att utöka inlärning och terapi, bara genom att klicka på en knapp!\n\nSe personalens användning och förbättra effektiviteten i hela din organisation tack vare möjligheten att administrera konton och data centralt, samt avancerad delning och samarbetsverktyg.",
    "topReasons": {
      "header": "Anledningar att registrera sig på myBoardmaker Organization",
      "points": [
        "Ett molnbaserat system främjar konsekvens och samarbete inom hela organisationen och personalen kan jobba varifrån som helst.",
        "Omfattande bibliotek med provaktiviteter redan anpassade för college- och yrkesutbildningsstandarder och din stats specifika standarder",
        "Elever får åtkomst till instruktionsaktiviteter från valfri dator var som helst",
        "Aktiviteter kan kopplas till individuella elevmål för att visa elevens framsteg",
        "Omedelbar åtkomst till data om elevens framsteg och personalanvändning, allt från ett system"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Skapa och redigera",
        "featureDescription": "Skapa och redigera symbolanpassade aktiviteter såsom visuella scheman för att planera dagen, individanpassade böcker och inlärningsmaterial, och beteendestöd! Med ett bibliotek med fler än 80 000 symboler att välja mellan, plus nya som läggs till varannan vecka, är möjligheterna oändliga. Behöver du mer? Använd vårt webbsökningsalternativ för att hämta mediafiler till ditt projekt."
      },
      {
        "featureTitle": "Skriv ut och spela",
        "featureDescription": "Skriv ut dina egna aktiviteter eller andra du hittar i Boardmaker Community direkt från webbläsaren Vill du öka engagemanget? Uppmuntra teamet att prova våra interaktiva mallar och aktiviteter. Elever kan enkelt utföra aktiviteter via den fullt tillgängliga gratisappen Student Center och ingen internetuppkoppling krävs."
      },
      {
        "featureTitle": "Lär ut och utöka",
        "featureDescription": "Ge din personal tillgång till tre robusta, standardinriktade kursplaner, alla inkluderade i prenumerationen på Boardmaker Online Organization. Boardmaker Instructional Solutions innehåller fler än 140 lektionsplaner som beskrivs steg för steg, fler än 1500 differentierade och standardjusterade aktiviteter, 300+ utskrivningsbara och tillgängliga böcker, verktyg för klassrumsadministration, frågesporter, spel, recept, pyssel, m.m."
      },
      {
        "featureTitle": "Tilldela och spåra",
        "featureDescription": "Med ett Boardmaker Online Organization-konto kan personalen tilldela person- och nivåanpassade aktiviteter till ett obegränsat antal elever för att spåra deras individuella framsteg i förhållande till deras individuella elevmål och statliga och lokala standarder. De kan sedan använda verktyget för elevövervakning för att snabbt se elevernas prestationer och enkelt rapportera om deras framsteg. Även tilldelade aktiviteter som slutförs hemma spåras så att de enkelt kan hantera läxor och samarbeta med barnets familj för att utöka lärandet utanför klassrummet."
      },
      {
        "featureTitle": "Hitta och dela",
        "featureDescription": "Varför skapa hjulet på nytt? Välj bland fler än 60 000 gratis befintliga utskrivningsbara och interaktiva aktiviteter och 1100 kategoriserade offentliga grupper i Boardmaker Community - den största delningsgemenskapen av sitt slag i världen. Du kan också ladda upp aktiviteter du har skapat till ditt Boardmaker Online Community-konto och dela dem med föräldrar, terapeuter eller elevens stödteam."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Kostnadsbesparande",
        "advantagePoints": [
          "Exklusiva anpassade verksamhetspaket för fem eller fler konton",
          "Molnbaserade tjänster gör det enkelt att omtilldela licenser vid personalbyte",
          "Volympriser",
          "Paket med flera produkter",
          "Besparing för flera år"
        ]
      },
      {
        "advantageTitle": "Framgång för alla",
        "advantagePoints": [
          "Forskningsbaserade aktiviteter, färdiga att använda, säkerställer positiva och mätbara resultat",
          "Vårt anpassade utbildningsmaterial och våra aktiviteter, vilka följer Universell design för lärande, gör inlärningsmål möjliga att uppnå för individer med olika förmågor",
          "Anpassade kursplan ger alla samma tillgång",
          "Tillgängliga resurser för att innefatta bästa praxis enligt expertis, vilket säkerställer att du får ut mesta möjliga av dina lösningar"
        ]
      },
      {
        "advantageTitle": "Uppfyller standarder och krav",
        "advantagePoints": [
          "Lösningar specifikt utformade för att lära ut och mäta framsteg mot standarder för college- och yrkesberedskap",
          "Ett brett utbud av lösningar som uppfyller kraven för Universell design för lärande, Every Child Succeeds och Individuals with Disabilities Education Act",
          "spåra och rapportera automatiskt framsteg mot planen för individuella elevmål via datainstrumentpanelen"
        ]
      },
      {
        "advantageTitle": "Enkel driftsättning inom organisationen",
        "advantagePoints": [
          "Låter administratörer tillhandahålla och driftsätta konton på distans på bara några sekunder",
          "Flexibla och skalbara alternativ för driftsättning inom organisationen",
          "Alla molnbaserade lösningar styrs från ett mycket säkert nivå 1-datacenter",
          "Gratis automatiska molnbaserade uppdateringar med nya spännande funktioner och resurser"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senare"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senare"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senare"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuell"],
        ["Firefox", "v38.0", "aktuell"],
        ["Safari", "v11.0", "aktuell"],
        ["Edge", "v83.0.478.45", "aktuell"],
        ["Internet Explorer", "v10.0", "v11.0 eller senare"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Nästa generation av mjukvaran Boardmaker har kommit!  Boardmaker 7 tar med sig alla de bästa funktionerna från tidigare versioner och lägger in dem i en multi-plattform och app med flera språk.  Boardmaker 7 har ett effektiviserat användargränssnitt där de verktyg du behöver är lättåtkomliga.  Den inkluderar de senaste PCS-symbolerna, men är ändå bakåtkompatibel med alla dina gamla tavlor och aktiviteter. I denna nya mjukvara kan du skapa och tillhandahålla anpassade kursplaner och kommunikationsstöd snabbare än någonsin tidigare.",
    "topReasons": {
      "header": "De främsta orsakerna till att köpa mjukvaran Boardmaker 7",
      "points": [
        "Redigera, skriv ut och kör alla dina gamla Boardmaker-filer",
        "Intuitivt, modernt gränssnitt med inbyggda ledtrådar och utbildningsmaterial",
        "Fantastiska mallar som snabbt och enkelt kan anpassas",
        "Hitta snabbt de symboler och bilder du behöver"
      ]
    },
    "summaryEnd": "Hämta din gratis 30 dagars testperiod idag!",
    "features": [
      {
        "featureTitle": "Öppnar allt du har skapat",
        "featureDescription": "Slösa inte bort många års hårt arbete ... Med mjukvaran Boardmaker 7 kan du öppna alla filer som skapats med Boardmaker v5, Boardmaker v6 eller Boardmaker Studio.  Konvertering sker snabbt och korrekt och även komplexa interaktiva aktiviteter kommer att fungera och se ut som originalet."
      },
      {
        "featureTitle": "Lätt som en plätt",
        "featureDescription": "Användarna har talat!  Omfattande användartester med människor som dig har informerat oss om att gränssnittet i Boardmaker 7 är modernt, välkomnande och intuitivt.  De inbyggda ledtrådarna och utbildningsmaterialet ger dig mod att utforska, utveckla dina förmågor och, viktigast av allt, ge stöd till dina elever."
      },
      {
        "featureTitle": "Snabbt/sparar tid",
        "featureDescription": "Med omdesignade mallar både för utskrift och interaktiva aktiviteter kommer du förvånas över bredden och djupet i det du kan prestera på bara några minuter.  Du kommer att vara klar med det där schemat eller den sociala berättelsen på nolltid vilket ger dig mer tid att ägna åt de elever som du har hand om.  Boardmaker gör det också enkelt att anpassa det du har skapat så att du får den perfekta kombinationen mellan snabbhet och flexibilitet."
      },
      {
        "featureTitle": "Överlägsen symbolsökning",
        "featureDescription": "Symboler är de vi är. Boardmaker 7 kan skryta med en förbättrad funktion för symbolsökning och ett intuitivt sätt att bläddra bland symboler efter kategori, men det är bara början.  Du kan söka efter delar av ord, rimord, individuella stavelser och konsonant-/vokalmönster. Detta är det kraftfullaste tillgängliga sökredskapet!  Och om du inte skulle hitta den där speciella symbolen kan du med den inbyggda webbsökningen och kameran lägga till foton snabbt och enkelt."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 eller senare"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senare"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senare"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 eller senare"],
        ["Android-enheter i", "Tobii Dynavox T-Series ", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
